import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const InnerWrapper = styled("div")`
    display: flex;
    height: 2.75rem;
    flex: 1 1 0;
    background-color: inherit;
    z-index: 2;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    align-items: center;
    max-width: ${breakpoints.values.xl}px;
    border-bottom: 1px solid;
    border-color: ${({theme}) => theme.uxfabric.components.appBar.brandBar.secure.borderColor};

    padding: 0.5rem 0.25rem 0.5rem 0;

    @media (min-width: ${breakpoints.values.md}px) {
        height: 3.75rem;
        padding: 0.5rem 2rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        padding: 0.5rem 2.5rem;
    }

    .header-adaptive-brand a {
        height: auto;
    }

    .countrylangselector {
        button {
            pointer-events: none;
        }
        padding-left: 0.875rem;
    }

    .header-secure-icon {
        padding-left: 0;
        height: 2.75rem;
        width: 2.75rem;
        align-content: center;
        text-align: center;
    }

    .header-secure-help-link {
        padding-right: 0;
        margin-right: 0.5rem;
    }
`
